import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const HelpService = {
  actions: {
    fetchAllHelps ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/helps',
          method: 'GET'
        })
          .then(resp => {
            const helps = resp.data.helps
            commit('api_success')
            resolve(resp)
            return helps
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    editHelp ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/help/' + data.id,
          data: data,
          method: 'PUT'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default HelpService



// WEBPACK FOOTER //
// ./src/store/modules/help.module.js